import type { Except } from '@festina-life/core'
import { Card, CardHeader } from '@festina-life/ui/structure'
import type { ComponentProps } from 'react'

import { LifeErrorFallback } from '../errorFallback/LifeErrorFallback'

type Props = Except<ComponentProps<typeof Card>, 'fallbackTitle'> & {
  headerProps: ComponentProps<typeof CardHeader>
}

export const LifeCard = ({
  ErrorFallback = LifeErrorFallback,
  children,
  headerProps,
  ...cardProps
}: Props) => (
  <Card
    fallbackTitle={headerProps?.title}
    {...cardProps}
    ErrorFallback={ErrorFallback}
  >
    <CardHeader {...headerProps} />
    {children}
  </Card>
)
